import { render, staticRenderFns } from "./marketing-list-details.vue?vue&type=template&id=6e528ccc"
import script from "./marketing-list-details.vue?vue&type=script&lang=js"
export * from "./marketing-list-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports